import React from 'react'
import PropTypes from 'prop-types'

import { stringContainsHTMLMarkup, checkParseAlertString } from 'shared/imports/sharedHelperFunctions'

import { renderText } from 'search-new/components/Inline/shared/functions'


const MAX_HIDDEN_SNIPPETS = 3

const Snippets = (props) => {
    const renderSnippet = (snippet) => {
        const snippetText = checkParseAlertString(snippet)

        return (
            <p key={`${props.inlineId}${snippet}`} className="text-section">
                {
                    renderText({
                        lineData: snippetText,
                        isHtml: stringContainsHTMLMarkup(snippetText),
                        inlineId: props.inlineId,
                        isSearchify: props.isSearchify,
                    })
                }
            </p>
        )
    }

    const renderSnippets = (inputSnippets) => {
        let snippets = inputSnippets

        if (snippets.map) {
            if (!props.isExpanded) {
                snippets = snippets.filter((element, index) => (index < MAX_HIDDEN_SNIPPETS))
            }

            snippets = Array.from(new Set(snippets))

            return (
                <div className="snippets">
                    {snippets.map(snippet => renderSnippet(snippet))}
                </div>
            )
        }

        return renderSnippet(snippets)
    }

    if (props.snippets) {
        return renderSnippets(props.snippets)
    } else if (props.alertSnippets) {
        let prevKey

        return (
            <div className="alert-snippets">
                {
                    Object.entries(props.alertSnippets).map(([snippetKey, snippetValue]) => {
                        if (snippetValue && snippetValue.length === 0) {
                            prevKey = snippetKey
                            return undefined
                        }

                        return (
                            <div
                                key={`${props.inlineId}${snippetKey}`}
                                className="alert-snippet-item"
                            >
                                <b>{snippetKey === "full_content" ? prevKey : snippetKey}</b>
                                {renderSnippets(snippetValue)}
                            </div>
                        )
                    })
                }
            </div>
        )
    }

    return null
}

Snippets.propTypes = {
    // snippets in the FeedItem Inline
    alertSnippets: PropTypes.object,
    // snippets in Bill and Webpage Inlines
    snippets: PropTypes.arrayOf(PropTypes.string),
    // whether or not the `Show More` button has been pressed
    isExpanded: PropTypes.bool,
    // whether or not we are in searchify
    isSearchify: PropTypes.bool,
    // the unique id of the Inline
    inlineId: PropTypes.number,
}

export default Snippets
